module.exports = __webpack_public_path__ + "static/media/home_history.c6001237.png";